import styled from 'styled-components'

//@ts-ignore
import { Card, Media } from 'reactstrap'
import Moment from 'react-moment'

export const StyledCard = styled(Card)`
  box-shadow: 0px 4px 6px rgba(75, 75, 75, 0.12) !important;
  border-radius: 20px;
`

export const Title = styled.h5`
  word-break: break-word;
  margin-bottom: 0rem !important;
  margin-left: 0.5rem !important;
  color: var(--text-heading);
`

export const Message = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: medium;
  color: var(--text-muted);
`

export const NotificationItem = styled(Media)`
  padding: 0.9rem 1.28rem;
  border: none;
  border-bottom: 1px solid var(--theme-border);
  &:hover {
    background-color: var(--surface-muted);
  }
`

export const StyledMoment = styled(Moment)`
  color: var(--text-muted);
  min-width: fit-content;
  margin-left: 1rem;
`
